import { render, staticRenderFns } from "./CollectionPointRegisterFormPage.vue?vue&type=template&id=26c643dc&scoped=true"
import script from "./CollectionPointRegisterFormPage.vue?vue&type=script&lang=js"
export * from "./CollectionPointRegisterFormPage.vue?vue&type=script&lang=js"
import style0 from "./CollectionPointRegisterFormPage.vue?vue&type=style&index=0&id=26c643dc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c643dc",
  null
  
)

export default component.exports